import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import WorkerLayout from "../Layouts/WorkerLayout";
import PagesLayaut from '../Layouts/PagesLayaut'
import { createBrowserRouter } from "react-router-dom";
import Productos from '../Pages/Productos/Productos'
import Usuarios from '../Pages/Usuarios/Usuarios'
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Horarios from "./Horarios/Horarios";
import Codigos from "./Codigos/Codigos";
import PageDetail from '../Pages/PageDetail/PageDetail';
import PageProductos from "./PageProductos/PageProductos";
import Pedidos from "./Pedidos/Pedidos";
import Mesas from "./Mesas/Mesas";
import Trabajadores from "./Trabajadores/Trabajadores";
import WorkerHome from "./WorkerHome/WorkerHome";
import WorkerPedidos from "./WorkerPedidos/WorkerPedidos";
import WorkerPedidosWeb from "./WorkerPedidosWeb/WorkerPedidosWeb";
import Reportes from "./Reportes/Reportes";
import Sucursales from "./Sucursales/Sucursales";
import Cajas from "./Cajas/Cajas";
import Qr from "./Qr/Qr";
import Registros from "./Registros/Registros";
import Solicitudes from "./Solicitudes/Solicitudes";
import { PlusRoute, NoTiendaRoute } from "../Components/PlanGate";

// Rutas hijas compartidas entre la demo (raíz) y los tenants (/:slug).
// Usan paths relativos para poder montarse bajo ambos prefijos.
const publicPages = [
    {
        path: `producto/:idProducto/:producto`,
        element: <PageDetail />,
    },
    {
        path: `productos`,
        element: <PageProductos />,
    },
];

const dashboardPages = [
    {
        path: `dashboard`,
        element: <Main />,
    },
    {
        path: `dashboard/productos`,
        element: <Productos />,
    },
    {
        path: `dashboard/usuarios`,
        element: <Usuarios />,
    },
    {
        path: `dashboard/banners`,
        element: <Banners />,
    },
    {
        path: `dashboard/contacto`,
        element: <Contacto />,
    },
    {
        path: `dashboard/categorias`,
        element: <Categorias />,
    },
    {
        path: `dashboard/horarios`,
        element: <Horarios />,
    },
    {
        path: `dashboard/codigos`,
        element: <PlusRoute><Codigos /></PlusRoute>,
    },
    {
        path: `dashboard/pedidos`,
        element: <PlusRoute><Pedidos /></PlusRoute>,
    },
    {
        path: `dashboard/reportes`,
        element: <PlusRoute><Reportes /></PlusRoute>,
    },
    {
        path: `dashboard/cajas`,
        element: <PlusRoute><Cajas /></PlusRoute>,
    },
    {
        path: `dashboard/mesas`,
        element: <PlusRoute><NoTiendaRoute><Mesas /></NoTiendaRoute></PlusRoute>,
    },
    {
        path: `dashboard/trabajadores`,
        element: <PlusRoute><Trabajadores /></PlusRoute>,
    },
    {
        path: `dashboard/sucursales`,
        element: <PlusRoute><Sucursales /></PlusRoute>,
    },
    {
        path: `dashboard/qr`,
        element: <Qr />,
    },
];

const workerPages = [
    {
        path: `trabajador`,
        element: <PlusRoute redirectTo="/dashboard"><WorkerHome /></PlusRoute>,
    },
    {
        path: `trabajador/pedidos`,
        element: <PlusRoute redirectTo="/dashboard"><WorkerPedidos /></PlusRoute>,
    },
    {
        path: `trabajador/pedidos-web`,
        element: <PlusRoute redirectTo="/trabajador"><WorkerPedidosWeb /></PlusRoute>,
    },
];

export const router = createBrowserRouter([
    // --- Rutas de plataforma (sin tenant) ---
    {
        path: "/registros",
        element: <Registros />,
    },
    {
        path: "/master",
        element: <Solicitudes />,
    },

    // --- Demo (raíz) ---
    {
        path: "/",
        element: <IndexLayout />,
    },
    {
        path: "/",
        element: <PagesLayaut />,
        children: publicPages,
    },
    {
        path: "/",
        element: <MainLayout />,
        children: dashboardPages,
    },
    {
        path: "/",
        element: <WorkerLayout />,
        children: workerPages,
    },

    // --- Tenants (/:slug) ---
    {
        path: "/:slug",
        element: <IndexLayout />,
    },
    {
        path: "/:slug",
        element: <PagesLayaut />,
        children: publicPages,
    },
    {
        path: "/:slug",
        element: <MainLayout />,
        children: dashboardPages,
    },
    {
        path: "/:slug",
        element: <WorkerLayout />,
        children: workerPages,
    },
]);
